import {
  addAutofillEventListener,
  removeAutofillEventListener,
} from './trackAutofillEvents';
import { addCopyPasteListeners, removeCopyPasteListeners } from './copyPaste';
import { addFluencyEventListeners, removeFluencyEventListeners } from './trackFluencyEvents';
import { addBackspaceEventListeners, removeBackspaceEventListeners } from './trackBackspaces';
import { addSelectionSelectedEventListeners, removeSelectionSelectedEventListeners } from './trackSelectionEvents';
import { addScrollEventListeners, removeScrollEventListeners } from './trackScrollDepth';
import { addLinkClickEventListeners, removeLinkClickEventListeners } from './trackLinkClicks';
import { addValidationErrorListeners, removeValidationErrorListeners } from './trackValidationErrors';

function addAllBehaviorTrackingListeners() {
  addAutofillEventListener();
  addCopyPasteListeners();
  addFluencyEventListeners();
  addBackspaceEventListeners();
  addSelectionSelectedEventListeners();
  addScrollEventListeners();
  addLinkClickEventListeners();
  addValidationErrorListeners();
}

function removeAllBehaviorTrackingListeners() {
  removeAutofillEventListener();
  removeCopyPasteListeners();
  removeFluencyEventListeners();
  removeBackspaceEventListeners();
  removeSelectionSelectedEventListeners();
  removeScrollEventListeners();
  removeLinkClickEventListeners();
  removeValidationErrorListeners();
}

export {
  addAllBehaviorTrackingListeners,
  removeAllBehaviorTrackingListeners,
};
